import $ from "jquery"
import toastr from "toastr"

// Shared field-visibility toggle logic
// Usage:
// 1) Prefer setting data-profile-attribute-key on .profile-form
// 2) Backward compatible: initFieldToggles('sender_profile_attributes')

function fieldNameFor(profileAttributeKey) {
  return 'user[' + profileAttributeKey + '][hidden_fields][]';
}

function hiddenFieldsFromForm(form) {
  var hiddenFields = [];
  $('.field-visibility-toggle', form).each(function() {
    if (!this.checked) hiddenFields.push(this.dataset.field);
  });
  return hiddenFields;
}

function syncHiddenFieldsInputs(form, profileAttributeKey) {
  if (!profileAttributeKey) return;

  var fieldName = fieldNameFor(profileAttributeKey);
  var hiddenFields = hiddenFieldsFromForm(form);
  $('input[name="' + fieldName + '"]', form).remove();

  if (!hiddenFields.length) {
    $('<input>').attr({ type: 'hidden', name: fieldName, value: '' }).appendTo(form);
    return;
  }

  hiddenFields.forEach(function(field) {
    $('<input>').attr({ type: 'hidden', name: fieldName, value: field }).appendTo(form);
  });
}

function resolveProfileId(form, profileAttributeKey) {
  if (form.dataset.profileId) return form.dataset.profileId;
  return $('input[name="user[' + profileAttributeKey + '][id]"]', form).val();
}

function autosaveHiddenFields(form) {
  if (!form || form.dataset.autosaveHiddenFields !== 'true') return null;

  var profileAttributeKey = form.dataset.profileAttributeKey;
  if (!profileAttributeKey) return null;

  var profileId = resolveProfileId(form, profileAttributeKey);
  if (!profileId) return null;

  syncHiddenFieldsInputs(form, profileAttributeKey);

  var hiddenFields = hiddenFieldsFromForm(form);
  var payload = { user: {} };
  payload.user[profileAttributeKey] = {
    id: profileId,
    // Keep the key present even when empty so backend can clear hidden_fields.
    hidden_fields: hiddenFields.length ? hiddenFields : ['']
  };

  // If user toggles rapidly, cancel the previous request and keep the latest state.
  if (form._hiddenFieldsRequest && form._hiddenFieldsRequest.readyState !== 4) {
    form._hiddenFieldsRequest.abort();
  }

  form._hiddenFieldsRequest = $.ajax({
    url: form.action,
    type: 'PATCH',
    data: payload,
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
  });

  return form._hiddenFieldsRequest;
}

function bindFieldToggleEvents() {
  // Use delegated listener with namespace so re-running this (Turbolinks) doesn't stack
  $(document)
    .off('change.fieldToggle')
    .on('change.fieldToggle', '.field-visibility-toggle', function() {
      var toggle = this;
      var previousValue = !toggle.checked;
      var form = toggle.closest('form.profile-form');

      if (!form) return;

      var request = autosaveHiddenFields(form);
      if (request) {
        request
          .done(function() {
            toastr.remove();
            if (toggle.checked) {
              toastr.success('Field is now visible to public');
            } else {
              toastr.info('Field is now hidden from public');
            }
          })
          .fail(function(xhr, status) {
            if (status === 'abort') return;
            toggle.checked = previousValue;
            syncHiddenFieldsInputs(form, form.dataset.profileAttributeKey);
            toastr.remove();
            toastr.error('Could not save toggle. Please try again.');
          });
        return;
      }

      // Fallback behavior when autosave is not enabled for this form.
      toastr.remove();
      if (toggle.checked) {
        toastr.success('Field is now visible to public');
      } else {
        toastr.info('Field is now hidden from public');
      }
    });

  // Build hidden_fields array for the submitted profile form
  $(document)
    .off('submit.fieldToggle', '.profile-form')
    .on('submit.fieldToggle', '.profile-form', function() {
      var form = this;
      var profileAttributeKey = form.dataset.profileAttributeKey;
      if (!profileAttributeKey) return;
      syncHiddenFieldsInputs(form, profileAttributeKey);
    });
}

window.initFieldToggles = function(profileAttributeKey) {
  var $forms = $('.profile-form');
  if (!$forms.length) return;

  if (profileAttributeKey) {
    $forms.each(function() {
      this.dataset.profileAttributeKey = profileAttributeKey;
    });
  }

  bindFieldToggleEvents();
};

$(document).on('turbolinks:load', function() {
  bindFieldToggleEvents();
});
